// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "dashboard" : chunkId) + "." + {"120":"beea553f","219":"d63924f6","856":"d25e7139","966":"dae2bc8e"}[chunkId] + ".js";
};